import dayjs from 'dayjs';

export default function getDaysForTwoWeeks(centerStart: dayjs.Dayjs) {
  const start = centerStart.subtract(7, 'day');
  return Array.from({ length: 14 }, (_, i) => start.add(i, 'day').format('YYYY-MM-DD'));
}

export function getDaysForThreeWeeks(centerStart: dayjs.Dayjs) {
  const start = centerStart.subtract(7, 'day');
  return Array.from({ length: 21 }, (_, i) => start.add(i, 'day').format('YYYY-MM-DD'));
}

interface IrrigationProgramProps {
  days: string[];
  readOnly?: boolean;
}

interface IrrigationData {
  programmedMm: (string | null)[];
  realMm: (string | null)[];
  irrigationTimeHours: (string | null)[];
  programmedCdtec: (string | null)[];
}

interface ReadOnlyCellProps {
  value: string | null;
  backgroundColor: string;
}

interface EditableCellProps {
  value: string | null;
  isEditing: boolean;
  canEdit: boolean;
  backgroundColor: string;
  onEdit: () => void;
  onChange: (value: string) => void;
  onBlur: () => void;
}

const BACKGROUND_COLORS = {
  PAST: '#f5f5f5',
  CURRENT: '#e3f2fd',
  FUTURE: '#ffffff',
} as const;

const BORDER_STYLES = {
  VERTICAL_THIN: '1px solid rgba(224, 224, 224, 1)',
  VERTICAL_THICK: '2px solid rgba(224, 224, 224, 1)',
  HORIZONTAL_HEADER: '2px solid rgba(224, 224, 224, 1)',
  NONE: 'none',
} as const;

const ROW_LABELS = {
  programmed: 'Riego Programado (mm)',
  real: 'Riego Real (mm)',
  cdtec: 'Riego CDTEC (mm)',
  difference: 'Diferencia CDTEC - Real (mm)',
  irrigationTime: 'Horas de riego real',
  theoreticalTime: 'Horas de riego teórica',
} as const;

export {
  BACKGROUND_COLORS,
  BORDER_STYLES,
  ROW_LABELS,
  IrrigationProgramProps,
  IrrigationData,
  ReadOnlyCellProps,
  EditableCellProps,
};
